import { createConfig, configureChains } from 'wagmi';
import { bscTestnet } from 'wagmi/chains';
import { publicProvider } from 'wagmi/providers/public';
import { MetaMaskConnector } from 'wagmi/connectors/metaMask';
// import { WalletConnectConnector } from 'wagmi/connectors/walletConnect';
// import { CoinbaseWalletConnector } from 'wagmi/connectors/coinbaseWallet';
import { InjectedConnector } from 'wagmi/connectors/injected';

// 配置链和提供者
const { chains, publicClient } = configureChains(
  [bscTestnet],
  [publicProvider()]
);

// 配置多种钱包连接器（暂时禁用WalletConnect）
const connectors = [
  new MetaMaskConnector({ chains }),
  // 暂时注释掉WalletConnect，需要有效的Project ID
  // new WalletConnectConnector({
  //   chains,
  //   options: {
  //     projectId: 'YOUR_PROJECT_ID', // 需要替换为实际的Project ID
  //     showQrModal: true,
  //   },
  // }),
  // new CoinbaseWalletConnector({
  //   chains,
  //   options: {
  //     appName: 'DOR Digital Open Reward Dollar',
  //   },
  // }),
  new InjectedConnector({
    chains,
    options: {
      name: 'Injected',
      shimDisconnect: true,
    },
  }),
];

// 创建Wagmi配置
export const wagmiConfig = createConfig({
  autoConnect: true,
  connectors,
  publicClient,
});

export { chains }; 